/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import template from './email-translation-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-email-translation-list-page',
  template
})
export class EmailTranslationListPageComponent extends AdminResourceListPageBase implements OnInit {
  readonly itemStateName = 'app.adm.email-translations.email-translation';

  showTeams = false;
  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'emailType', param: 'messageDefinition'},
    {label: 'applications', param: '', sortable: false},
    {label: 'locale', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private LocalUserPermissions: any
  ) {
    super(LocalNetworkProfile);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.showTeams = !!this.LocalUserPermissions.getAllVisPermissions().MANAGE_SYSTEM;
    this.columns = [
      ...this.columns,
      ...(this.showTeams ? [{label: 'team', param: '', sortable: false} as AdminListColumn] : []),
      {label: 'emailTemplate', param: '', sortable: false}
    ];
  }
}
